export default {
    icon: "el-icon-discount",
    title: "商品推荐",
    name: "promotionList",
    timestamp: "1709627778508010",
    setUp: {
        tabVal: 0
    },
    productList: {
        title: "促销列表",
        list: []
    },
    titleConfig: {
        title: "标题位置",
        type: 2,
        list: [
            {
                val: "居左",
                icon: "icondoc_left"
            },
            {
                val: "居中",
                icon: "icondoc_center"
            },
            {
                val: "居右",
                icon: "icondoc_right"
            }
        ]
    },
    titleShow: {
        title: "是否显示商品名称",
        val: true
    },
    opriceShow: {
        title: "是否显示商品原价",
        val: true
    },
    priceShow: {
        title: "是否显示商品价格",
        val: true
    },
    couponShow: {
        title: "是否显示优惠券",
        val: true
    },
    tabConfig: {
        title: "最多可添加4个版块；鼠标拖拽左侧圆点可调整版块顺序",
        max: 4,
        tabCur: 3,
        list: [
            {
                child: [
                    {
                        title: "标题",
                        val: "首发新品",
                        max: 4,
                        pla: "选填，不超过四个字"
                    },
                    {
                        title: "简介",
                        val: "最新出炉",
                        max: 4,
                        pla: "选填，不超过四个字"
                    }
                ],
                link: {
                    title: "链接",
                    activeVal: 3,
                    optiops: [
                        {
                            type: 0,
                            value: 1,
                            label: "精品推荐"
                        },
                        {
                            type: 1,
                            value: 2,
                            label: "热门榜单"
                        },
                        {
                            type: 2,
                            value: 3,
                            label: "首发新品"
                        },
                        {
                            type: 3,
                            value: 4,
                            label: "促销单品"
                        }
                    ]
                }
            },
            {
                child: [
                    {
                        title: "标题",
                        val: "精品推荐",
                        max: 4,
                        pla: "选填，不超过四个字"
                    },
                    {
                        title: "简介",
                        val: "猜你喜欢",
                        max: 4,
                        pla: "选填，不超过四个字"
                    }
                ],
                link: {
                    title: "链接",
                    activeVal: 1,
                    optiops: [
                        {
                            type: 0,
                            value: 1,
                            label: "精品推荐"
                        },
                        {
                            type: 1,
                            value: 2,
                            label: "热门榜单"
                        },
                        {
                            type: 2,
                            value: 3,
                            label: "首发新品"
                        },
                        {
                            type: 3,
                            value: 4,
                            label: "促销单品"
                        }
                    ]
                }
            },
            {
                child: [
                    {
                        title: "标题",
                        val: "热门榜单",
                        max: 4,
                        pla: "选填，不超过四个字"
                    },
                    {
                        title: "简介",
                        val: "好评如云",
                        max: 4,
                        pla: "选填，不超过四个字"
                    }
                ],
                link: {
                    title: "链接",
                    activeVal: 2,
                    optiops: [
                        {
                            type: 0,
                            value: 1,
                            label: "精品推荐"
                        },
                        {
                            type: 1,
                            value: 2,
                            label: "热门榜单"
                        },
                        {
                            type: 2,
                            value: 3,
                            label: "首发新品"
                        },
                        {
                            type: 3,
                            value: 4,
                            label: "促销单品"
                        }
                    ]
                }
            },
            {
                child: [
                    {
                        title: "标题",
                        val: "促销单品",
                        max: 4,
                        pla: "选填，不超过四个字"
                    },
                    {
                        title: "简介",
                        val: "多买多销",
                        max: 4,
                        pla: "选填，不超过四个字"
                    }
                ],
                link: {
                    title: "链接",
                    activeVal: 4,
                    optiops: [
                        {
                            type: 0,
                            value: 1,
                            label: "精品推荐"
                        },
                        {
                            type: 1,
                            value: 2,
                            label: "热门榜单"
                        },
                        {
                            type: 2,
                            value: 3,
                            label: "首发新品"
                        },
                        {
                            type: 3,
                            value: 4,
                            label: "促销单品"
                        }
                    ]
                }
            }
        ]
    },
    themeColor: {
        title: "主题风格",
        name: "themeColor",
        default: [
            {
                item: "#F95429"
            }
        ],
        color: [
            {
                item: "#F95429"
            }
        ]
    },
    fontColor: {
        title: "价格颜色",
        name: "fontColor",
        default: [
            {
                item: "#e93323"
            }
        ],
        color: [
            {
                item: "rgba(253,80,47,1)"
            }
        ]
    },
    labelColor: {
        title: "活动标签",
        name: "labelColor",
        default: [
            {
                item: "#e93323"
            }
        ],
        color: [
            {
                item: "#e93323"
            }
        ]
    },
    mbConfig: {
        title: "页面间距",
        val: 10,
        min: 0
    },
    numConfig: {
        val: 9
    },
    id: "id1709627778508010"
}